import * as React from "react";
import * as $ from "jquery";
import "jquery-ui/ui/widgets/autocomplete";
import * as classNames from "classNames";
import { IBaseFormElementProps, BaseFormElement } from "../../../../../react-core/Html/BaseFormElement";
import { IBaseTextBoxEditorProps, BaseTextBoxEditor } from "../../../../../react-core/Html/BaseTextBoxEditor";
import { InstrumentSearchQuery } from "../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { InstrumentSearchQueryClient } from "../../../../../Wrap/Api/Instruments/InstrumentSearchQuery";
import { ResultPageModel } from "../../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { Instrument } from "../../../../../Wrap/Models/Domains/Investment/Instrument";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { ProductOverviewCrystallisationAction } from "../../../../Dashboard/Components/Clients/PortfolioDashboard/Components/ProductOverview/Action/ProductOverviewCrystallisationAction";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";

export class AutocompleteResult {
    value: string;
    label: string;
    data: any;
}

interface IAutoCompleteSpecificProps extends IBaseFormElementProps {
    id?: string;
    cssWrapper?: string;
    placeholder?: string;
    query: InstrumentSearchQuery;
    hiercharyId: string;

    label?: string;

    onSelected: (item: any) => void;
    onChange?: (item: any) => void;
    onLookupError: () => void;

    automationId?: string;

    disabled?: boolean;

    subLabelId?: string;

    minLengh?: number;
    selectedPathwayText?: string;
}

interface IAutoCompleteProps extends IAutoCompleteSpecificProps, React.Props<AutoComplete> {}

export class AutoComplete extends BaseFormElement<IAutoCompleteProps, any> {
    private _InputRef: HTMLInputElement;

    private _find: InstrumentSearchQueryClient;
    private hasInitializedPathwayText: boolean = false;

    initState(){
        this.state = {ActiveTailoredDrawdownArrangement : null}
    }

    constructor(props: IAutoCompleteProps) {
        super(props);
        this.state = {};
        this._find = new InstrumentSearchQueryClient();
    }

    public setDisable() {
        this.setState({ disable: true });
    }

    public isValid(): boolean {
        return true;
    }

    public componentDidUpdate(prevProps: IAutoCompleteProps) {
        const currText = this.props.selectedPathwayText || "";
        const prevText = prevProps.selectedPathwayText || "";

        if (!this.hasInitializedPathwayText && currText !== "") {
            this.hasInitializedPathwayText = true;
            this.handlePathwayTextChange();
        } else if (prevText !== currText && currText !== "" && this.hasInitializedPathwayText) {
            this.handlePathwayTextChange();
        }
    }

    private handlePathwayTextChange() {
        const removeButtons = document.getElementsByClassName("remove-button label-sr-only");
        if (removeButtons.length > 0) {
            (removeButtons[removeButtons.length -1] as HTMLElement).click();
        }
        if (this._InputRef && this.props.selectedPathwayText !== "") {
            this._InputRef.value = this.props.selectedPathwayText; 
            const query = this.props.query;
            query["Name"] = this.getSearchValue();
            this._find.post(query, this.props.hiercharyId).onSuccess((results: ResultPageModel<Instrument>) => {
                const mappedSearchResults = this.transformSearchResults(results.Results);
                if (this._InputRef.value != null && mappedSearchResults.length >= 0 && mappedSearchResults[0].data != null) {
                    this.handleSearchResultSelection(mappedSearchResults[0]);
                }
            });
        }
    }

    public componentDidMount() {
        const $inputRef = $(this._InputRef);

        const autocomplete = ($inputRef as any)
            .autocomplete({
                source: (request, responseFn) => {
                    const query = this.props.query;
                    query["Name"] = this.getSearchValue();
                    this._find.post(query, this.props.hiercharyId).onSuccess((results: ResultPageModel<Instrument>) => {
                        const mappedSearchResults = this.transformSearchResults(results.Results);
                        responseFn(mappedSearchResults);
                    });
                },
                minLength: CommonHelper.isNullOrEmpty(this.props.minLengh) ? 3 : this.props.minLengh,
            })
            .on("autocompleteselect", (event: any, ui: any) => {
                this.handleSearchResultSelection(ui.item);
            });
        if (!CommonHelper.isNullOrEmpty(this.props.minLengh)) {
            autocomplete.focus(function () {
                ($inputRef as any).autocomplete("search");
            });
        }
        if(this.props.hiercharyId != null){
            ProductOverviewCrystallisationAction.getRegularCrystallisationDetails(this.props.hiercharyId, (data) => {
                this.setState({ ActiveTailoredDrawdownArrangement: data });
            })
        }
    }

    private transformSearchResults(items: any[]): Array<AutocompleteResult> {
        const results = new Array<AutocompleteResult>();

        if (!items.length) {
            const emptyResult: AutocompleteResult = {
                label: "No results found",
                value: null,
                data: null,
            };
            results.push(emptyResult);
            return results;
        } else {
            for (let i = 0; i < items.length; i++) {
                if (this.props.query.ProductTypes[0] !== ProductType.OffPlatform || !(this.state.ActiveTailoredDrawdownArrangement?.length > 0) && this.props.query.ProductTypes[0] === ProductType.OffPlatform || (this.state.ActiveTailoredDrawdownArrangement?.length > 0 && this.props.query.ProductTypes[0] === ProductType.OffPlatform && items[i].TailoredDrawdownAllowed )) {
                    const item = new AutocompleteResult();
                    item.data = items[i];
                    if (items[i].Name) {
                        item.label = items[i].Name;
                    }

                    results.push(item);
                }
            }

            return results;
        }
    }

    public render(): JSX.Element {
        const cssClassNames = classNames("form-group search-form", this.props.cssWrapper);
        return (
            <div className={cssClassNames}>
                <label className="control-label" htmlFor={this.props.id}>
                    {this.props.label}
                </label>
                <div className="controls-wrap">
                    <div className="controls-text">
                        <span className="search-icon"></span>
                        <input
                            type="text"
                            id={this.props.id}
                            className="search-input"
                            placeholder={this.props.placeholder}
                            disabled={this.state.disable == true ? true : this.props.disabled}
                            ref={(inputRef: HTMLInputElement) => (this._InputRef = inputRef)}
                            data-automation-id={this.props.automationId}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private handleSearchResultSelection(selectedResult: AutocompleteResult) {
        this.props.onSelected(selectedResult.data);
        setTimeout(() => {
            this._InputRef.value = "";
        }, 200);
    }

    private getSearchValue(): string {
        return this._InputRef.value;
    }
}

interface IAutoCompleteEditorProps
    extends IBaseTextBoxEditorProps,
        IAutoCompleteSpecificProps,
        React.Props<AutoCompleteEditor> {}

export class AutoCompleteEditor extends BaseTextBoxEditor<IAutoCompleteEditorProps> {
    constructor(props: IAutoCompleteEditorProps) {
        super(props);
    }

    protected getInput() {
        return <AutoComplete {...(this.props as any)} id={this.state.inputGroupId} />;
    }
}
